// extracted by mini-css-extract-plugin
export default {"container":"Welcome_container__Cm7ur","playerWrapper":"Welcome_playerWrapper__0EIhQ","control":"Welcome_control__uD9R8","buttonWrapper":"Welcome_buttonWrapper__qB5tY"};